function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "m8.9 10.22v2.47c0 .38.31.7.7.7h4.21c.38 0 .7-.31.7-.7v-6.19c0-.3-.12-.58-.33-.79l-5.89-4.88c-.44-.44-1.15-.44-1.58 0l-5.88 4.88c-.21.21-.33.49-.33.79v6.19c0 .38.31.7.7.7h4.21c.38 0 .7-.31.7-.7v-2.47c0-.77.63-1.4 1.4-1.4.77 0 1.4.63 1.4 1.4z",
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 15 13.88"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/home-outlined.0a42dd9a.svg";
export { SvgComponent as ReactComponent };